export default "__VITE_ASSET__Dw0kpcQN__"